import React from 'react';
import { Tooltip, Form, List, Card, Tabs, Menu, Select, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import styled from 'styled-components';
import Action from './Action';
import Title from './Title';
import Filter from './Filter';
import ToolbarContext from '../../Toolbar/ToolbarContext';

const PanelHeader = styled.div`
  background: rgb(42, 69, 93) !important;
  color: rgba(255, 255, 255, 0.65);
  padding: 0 8px;
  display: flex;
  height: 64px;
  align-items: center;
  
  & > * {
    margin-left: 8px;
  }
  
  & > *:last-child {
    margin-left: 0;
  }
`;

const PanelLoadingSpinner = styled(Icon)`
  margin-left: 8px;
`;

const PanelActions = styled.div`
  white-space: nowrap;
  text-align: right;
  margin-left: auto;
  flex: none;
  
  & > * {
    margin: 0 4px;
  }
`;

const Index = ({ children, actions, loading, onBack, onCancel }) => (
  <ToolbarContext.Consumer>
    {context => (
      <PanelHeader>
        {onBack && (
          <div>
            <Action onClick={onBack} icon="arrow-left" shape="circle" ghost />
          </div>
        )}
        {children}
        {loading && <div><Icon style={{ marginLeft: '8px' }} type="loading" theme="outlined" /></div>}
        <PanelActions>
          {actions}
          {(context.onClose && !onCancel) && <Action icon="close" onClick={context.onClose} />}
          {onCancel && <Action icon="close-circle" onClick={onCancel} />}
        </PanelActions>
      </PanelHeader>
    )}
  </ToolbarContext.Consumer>
);

Index.Action = Action;
Index.Title = Title;
Index.Filter = Filter;

export default Index;
